<template>
    <div
        class="LessonCard well m-0 p-0 relative text-sm flex flex-col pointer"
        style="border-radius: 18px;"
        :class="'--' + lesson.platform.slug"
    >
        <div class="LessonCard__cover">
            <cover-image :src="lesson.cover_image" class="b-rad-t-lg flex flex-center">
                <div class="LessonCard__cover__overlay absolute pos-t-l pos-b-r b-rad-t-lg"></div>
                <div class="LessonCard__cover__play">
                    <i class="fa fa-play-circle text-white"></i>
                </div>
            </cover-image>
        </div>
        <div class="p-5 flex flex-col flex-1">
            <h3 class="m-0" v-text="lesson.title" />

            <div class="py-5 text-gray-900" v-html="lesson.description" />
        </div>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.LessonCard {
    cursor: pointer;
}

.LessonCard__cover .CoverImage {
    padding-top: 56%;
    background-position-y: center;
}

.LessonCard__cover__play {
    position: absolute;
    top: 0;
    font-size: 60px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    height: 100%;
}

.LessonCard:hover .LessonCard__cover__play {
    font-size: 70px;
}

.LessonCard__cover__overlay {
    mix-blend-mode: color;
    opacity: 0.4;
}
.LessonCard.--analytics .LessonCard__cover__overlay {
    background: linear-gradient(297.24deg, #66a6ff 0%, #89f7fe 100%);
}
.LessonCard.--instagram .LessonCard__cover__overlay {
    background: linear-gradient(0deg, #e09b3d 0%, #c74c4d 30%, #c21975 60%, #7024c4 100%);
}
.LessonCard.--youtube .LessonCard__cover__overlay {
    background: linear-gradient(0deg, rgba(255, 177, 153, 0.7), rgba(255, 8, 68, 0.7));
}

/*
.LessonCard .PlatformIcon {
    font-size: 30px;
    bottom: 15px;
    right: 15px;
}
*/
/*
    .LessonCard__cover .CoverImage {
        @media (min-width: @screen-sm-min) {
            min-height: 230px;
        }

        @media (min-width: @screen-md-min) {
            min-height: 290px;
        }

        @media (min-width: @screen-lg-min) {
            min-height: 230px;
        }
    }

.LessonCard__content {
    @media (min-width: @screen-sm-min) {
        min-height: 230px;
    }

    @media (min-width: @screen-md-min) {
        min-height: 290px;
    }

    @media (min-width: @screen-lg-min) {
        min-height: 230px;
    }
}
*/
</style>

<script type="text/babel">
import PlatformIcon from 'dashboard-js/components/platforms/PlatformIcon'

export default {
    components: { PlatformIcon },

    props: ['lesson'],
}
</script>
